<template>
  <div class="form-group"
    :class="{'is-invalid-group':error || errorMessage}"
  >

    <label class="form-control-label" :for="name">{{ label }}</label>

    <div class="input-group input-group-merge">
      <div class="input-group-prepend" v-if="icon">
        <span class="input-group-text">
          <feather :type="icon" class="icon-dual"></feather>
        </span>
      </div>

      <b-form-select 
        :class="{ 'is-invalid': error || errorMessage }"
        :placeholder="placeholder"
        @input="$emit('update:name', $event)"
        :options='options'
        :value="value"
        @change="$emit('change', $event)"
      ></b-form-select>

   
    </div>
    <div class="invalid-feedback" v-if="errorMessage">
      {{ errorMessage }}
    </div>
    <div class="text-muted" v-if="help">
      {{ help }}
    </div>
    <!-- <ul 
        class="parsley-errors-list filled" 
        v-if="error"
      >
      <li>
          <div v-if="!required">This value is required.</div>
          <div v-if="!email">This value should be a valid email.</div>
      </li>
    </ul> -->
  </div>
</template>

<script>
export default {
  props:[
    'type', 
    'placeholder', 
    'label', 
    'icon', 
    'name', 
    'autocomplete', 
    'value', 
    'required', 
    'error', 
    'errorMessage', 
    'help', 
    'options'
  ],
}
</script>